import {
  actions,
  searchContentEntityPaginatedAsync,
  editContentEntityAsync,
  createContentEntityAsync,
  getContentEntityByIdAsync,
  getAllContentEntitiesByTypeAsync,
  getContentCollectionAsync,
  getContentEntitiesAsDataTableAsync,
  multiblePublishAsync,
  setPublishDateAsync,
  setPublishAsync,
  updateContentPlansAsync,
  getContentparentsAsync,
  getContentEntitiesByAuthorAsync,
  assignContentEntityAsync,
  orderItemAsync,
  unassignContentEntityAsync,
  createContentEntityByTypeAsync,
  getContentCollectionEntityByIdAsync,
  getContentCollectionEntityWithMediaAsync,
  addContentEntityByIdForHistoryAsync,
  deleteContentEntityAsync,
  getContentEntitiesToBeExportedAsync,
  getContentEntitiesBySelectorsAsync,
  getTopSearchedPhrasesAsync,
  searchTrackedAsync,
  getContentEntityItemsByIdAsync,
  getNextTitleAsync,
  getContentDetailsByIdAsync,
  searchTrackedDropdownAsync,
  setAdminOrderAsync,
  getContentEntityTagsAsync,
  setContentEntityTagsAsync,
  getContentDetailsByIdMultilingualAsync,
  getContentItemDetailsByIdMultilingualAsync,
  createContentEntityMultilingualAsync,
  editContentEntityMultilingualAsync,
  setExpectedPublishDateAsync,
  getContentEntityBadgeAsync,
  setContentEntityBadgeAsync,
} from './slices';
import { searchContentEntityPaginatedForSelector } from './thunks';

export const ContentEntityActions = {
  ...actions,
  searchContentEntityPaginatedAsync,
  editContentEntityAsync,
  createContentEntityAsync,
  getContentEntityByIdAsync,
  getAllContentEntitiesByTypeAsync,
  getContentCollectionAsync,
  getContentEntitiesAsDataTableAsync,
  multiblePublishAsync,
  getContentparentsAsync,
  setPublishDateAsync,
  setPublishAsync,
  updateContentPlansAsync,
  getContentEntitiesByAuthorAsync,
  assignContentEntityAsync,
  orderItemAsync,
  unassignContentEntityAsync,
  searchContentEntityPaginatedForSelector,
  createContentEntityByTypeAsync,
  getContentCollectionEntityByIdAsync,
  getContentCollectionEntityWithMediaAsync,
  addContentEntityByIdForHistoryAsync,
  deleteContentEntityAsync,
  getContentEntitiesToBeExportedAsync,
  getContentEntitiesBySelectorsAsync,
  getTopSearchedPhrasesAsync,
  searchTrackedAsync,
  getContentEntityItemsByIdAsync,
  getNextTitleAsync,
  getContentDetailsByIdAsync,
  searchTrackedDropdownAsync,
  setAdminOrderAsync,
  getContentEntityTagsAsync,
  setContentEntityTagsAsync,
  getContentDetailsByIdMultilingualAsync,
  getContentItemDetailsByIdMultilingualAsync,
  createContentEntityMultilingualAsync,
  editContentEntityMultilingualAsync,
  setExpectedPublishDateAsync,
  getContentEntityBadgeAsync,
  setContentEntityBadgeAsync,
};

export * from './types';

export * from './thunkHandlers';
